<template>
  <div class="user bkcolor-user">
    <van-nav-bar title="管理功能" left-text="返回" left-arrow @click-left="$router.push('/user')"/>
    <div v-show="info.userType == '0'" style="margin-top:10px">
      <van-cell-group title="统计功能" class="user-group">
        <van-cell icon="chart-trending-o" title="收入统计" title-style="float:left" is-link url="/adminincome" >
          <template slot="title">
            <span style="float:left">平台收入</span>
          </template>
        </van-cell>
        <van-cell icon="orders-o" title="订单查询" title-style="float:left" is-link url="/adminorder" >
          <template slot="title">
            <span style="float:left">订单查询</span>
          </template>
        </van-cell>

        <van-cell icon="manager-o" title="用户统计" title-style="float:left" is-link url="/adminuser?v=2" >
          <template slot="title">
            <span style="float:left">用户管理</span>
          </template>
        </van-cell>


        <van-cell icon="coupon-o" title="用户统计" title-style="float:left" is-link url="/adminuserincome?v=2" >
          <template slot="title">
            <span style="float:left">用户预估收入</span>
          </template>
        </van-cell>

        <van-cell icon="gift-card-o" title="账户流水" title-style="float:left" is-link url="/adminmoneylog?v=2" >
          <template slot="title">
            <span style="float:left">账户流水</span>
          </template>
        </van-cell>

        <van-cell icon="expand-o" title="提现走势" title-style="float:left" is-link url="/adminwithdrawlog?v=2" >
          <template slot="title">
            <span style="float:left">提现走势</span>
          </template>
        </van-cell>

        <van-cell icon="notes-o" title="提现统计" title-style="float:left" is-link url="/adminwithdrawlist?v=2" >
          <template slot="title">
            <span style="float:left">提现统计</span>
          </template>
        </van-cell>

      </van-cell-group>
      <van-cell-group title="管理功能" class="user-group">

        <van-cell icon="friends-o" title="代理设定" title-style="float:left" is-link url="/agent" >
          <template slot="title">
            <span style="float:left">代理设定</span>
            <van-icon
                    name="question-o"
                    color="#1989fa"
                    style="float:left;"
                    @click.stop="$toast('慎重操作')"
            />
          </template>
        </van-cell>
        <van-cell icon="bullhorn-o" title="发送通知" title-style="float:left" is-link url="/notify" >
          <template slot="title">
            <span style="float:left">发送通知</span>
          </template>
        </van-cell>

        <van-cell icon="coupon-o" title="发送通知" title-style="float:left" is-link url="/miandan" v-show="info.inviteCode == '0d45imox'">
          <template slot="title">
            <span style="float:left">免单</span>
          </template>
        </van-cell>


      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { Icon, Cell, CellGroup, NavBar } from "vant"
import fetch from '../../libs/fetch'
import {Dialog} from 'vant'
export default {
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup
  },
  data() {
    return {
      info: {
        totalMoney:'',
        money: '',
        userType: '3',
        avatarUrl: '',
        nickName: '',
        isEnable : '0',
        inviteCode: ''
      },
    };
  },
  mounted() {
    this.getUserInfo();
  },
  computed: {},
  methods: {
      getUserInfo() {
      const openid = localStorage.getItem('openId')
      let url = '/pdd-user/public/mp/user?openId=' + openid;
      fetch({
          url: url,
          method: 'get'
      }).then(response => {
          this.info.money = response.data.money
          this.info.totalMoney = response.data.totalMoney
          this.info.userType = response.data.userType
          this.info.nickName = response.data.nickName
          this.info.avatarUrl = response.data.avatarUrl
          this.info.isEnable = response.data.isEnable
          this.info.userType = response.data.userType
          this.info.inviteCode = response.data.inviteCode
      }).catch(error => {
          console.log(error)
          Dialog.alert({
              title: '系统提示',
              message: error
          }).then(() => {
              // on close
          })
      });
    }
  }
};
</script>

<style lang="less" scoped>
.bkcolor-user {
background-color: #f8f8f8;
padding-top: 0;
}
.user {
  padding-bottom: 55px;
}
.user-group {
    margin-bottom: 15px;
}
</style>
